module.exports = __webpack_public_path__ + "static/mobileHero-0a7fa9ff7e4fa162acaf06e3854a1fc2.png";